// import request from '@/utils/request';
import * as FetchAPI from '@/components/fetchService';
import { method } from 'lodash';

interface IsignUpParams {
  name: string;
  email: string;
  password: string;
  company: string;
}

const extractMessage = (obj: any): string | null => {
  if (!obj) return null;

  if (typeof obj === 'string') return obj;

  if (Array.isArray(obj)) {
    for (const item of obj) {
      const found = extractMessage(item);
      if (found) return found;
    }
  }

  if (typeof obj === 'object') {
    for (const value of Object.values(obj)) {
      const found = extractMessage(value);
      if (found) return found;
    }
  }

  return null;
};

export async function signup(params: IsignUpParams): Promise<any> {
  try {
    const response = await fetch('/auth_management/signup/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      body: JSON.stringify(params),
    });

    let data: any = {};
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    const message = !response.ok
      ? extractMessage(data) || 'Signup failed'
      : null;

    return {
      status: response.status,
      ok: response.ok,
      message,
      data,
    };
  } catch (err) {
    return {
      ok: false,
      status: 500,
      message: 'Network error. Please try again.',
    };
  }
}

export interface IsigninParams {
  email: string;
  password: string;
}

export async function signin(params: IsigninParams): Promise<any> {
  // return request('/auth_management/signin/', {
  //   method: 'POST',
  //   data: params,
  // });
  return FetchAPI.fetchAPIPOST('/auth_management/signin/', params);
}

export async function logoutFromServer(): Promise<any> {
  // return request('/auth_management/logout/', { method: 'POST' });
  return FetchAPI.fetchAPIPOST('/auth_management/logout/', {});
}

export async function queryCurrent(): Promise<any> {
  // return request('/auth_management/currentUser/');
  return FetchAPI.fetchAPIGET('/auth_management/currentUser/');
}

export async function getfetchsubscriptionStatus(): Promise<any> {
  // return request('/auth_management/currentUser/');
  return FetchAPI.fetchAPIGET('/inspections/api/user-subscriptions/');
}

export async function updateSubscriptionStatus(updation_details): Promise<any> {
  // return request('/auth_management/currentUser/');
  return FetchAPI.fetchAPIPOST('/inspections/api/user-subscriptions/', updation_details);
}

export async function getNotificationCounts(): Promise<any> {
  return FetchAPI.fetchAPIGET('/inspections/api/unread_notification_count/');
}


export interface IResetPasswordParams {
  email: string;
}

export async function requestResetPassword(params: IResetPasswordParams): Promise<any> {
  // return request('/auth_management/password/reset/', {
  //   method: 'POST',
  //   data: params,
  // });
  return FetchAPI.fetchAPIPOST('/auth_management/password/reset/', params);
}

export async function microsoftEmailFirstStart(params: { email: string; redirect_uri: string }): Promise<any> {
  return FetchAPI.fetchAPIPOST('/auth_management/microsoft/email-first/start/', params);
}

export async function microsoftEmailFirstComplete(params: { code: string; state: string }): Promise<any> {
  return FetchAPI.fetchAPIPOST('/auth_management/microsoft/email-first/complete/', params);
}


export async function requestconfirmResetPassword(params: IResetPasswordParams): Promise<any> {
  const baseurl = '/auth_management/password/reset/confirm/';
  const { uid } = params;
  let { token } = params;

  if (token[token.length - 1] === '.') {
    token = token.substring(0, token.length - 1);
  }
  // Token's last character is a dot, removing which makes the HTTP post submission work properly
  params.token = token;

  const acturl = `${baseurl + uid}/${token}/`;
  return FetchAPI.fetchAPIPOST(acturl, params);
}

export async function socialLogin(provider: string, id_token: string): Promise<any> {
  // /auth_management/social-login/ is our endpoint
  return await FetchAPI.fetchAPIPOST('/auth_management/social-login/', { provider, id_token });
}

export async function validateInvitation(params: { token: string }) {
  return fetch(`/auth_management/b2b/invitations/validate/${params.token}/`, {
    method: 'GET',
    credentials: 'include',
  }).then(res => res.json());
}


export async function ssoEmailFirstStart(payload: { email: string; redirect_uri: string }) {
  return FetchAPI.fetchAPIPOST('/auth_management/auth/sso/email-first/start/', payload);
}

export async function ssoEmailFirstComplete(payload: { code: string; state: string }) {
  return FetchAPI.fetchAPIPOST('/auth_management/auth/sso/email-first/complete/', payload);
}